import {Platform} from 'react-native';
import RNConfig from 'react-native-config';
import {adaptNetworkUrls} from './network.adapter';

const IS_WEB = Platform.OS === 'web';

const ENV_CONFIG = (IS_WEB ? process.env : RNConfig) as {
  REACT_APP_ENV: 'dev' | 'test' | 'uat' | 'prod' | 'local';
  REACT_APP_API_BASE_URL: string;
  REACT_APP_API_INDUSWIN_URL?: string;
  REACT_APP_API_SPORTS_URL?: string;
  REACT_APP_API_QUICK_URL?: string;
  REACT_APP_API_H5GAMES_URL?: string;
  REACT_APP_API_RACECAR_URL?: string;
  REACT_APP_API_LOTTO_URL?: string;
  REACT_APP_API_STATE_URL?: string;
  REACT_APP_IM_URL?: string;
  REACT_APP_API_IM_URL?: string;
  REACT_APP_FANTASY_CENTER_URL?: string;
  REACT_APP_BETBY_SCRIPT_URL?: string;
  REACT_APP_GR8_IFRAME_URL?: string;
  REACT_APP_DOWNLOAD_DOMAIN?: string;
  REACT_APP_SHARE_DOMAIN?: string;
  REACT_APP_GAME_PIC_CDN?: string;

  [k: string]: string | number | undefined;
};

class Config {
  private _IMURL: string;
  private _codePushKey: string;
  private _baseUrl: string;
  private _betbyScriptUrl: string;
  private _gr8IframeUrl: string;
  private _imApiUrl: string;
  private _downloadDomain: string;
  private _shareDomain: string;
  private _gamePicCdn: string;
  private _fantasyCenterUrl: string;

  get baseUrl() {
    return this._baseUrl;
  }

  private _induswinUrl!: string | undefined;
  get induswinUrl() {
    return this._induswinUrl;
  }

  private _sportsUrl!: string;
  get sportsUrl() {
    return this._sportsUrl;
  }

  private _quick3dUrl!: string;
  private _lqiUrl!: string;
  private _loiUrl!: string;

  get quick3dUrl() {
    return this._quick3dUrl;
  }

  get lqiUrl() {
    return this._lqiUrl;
  }

  get loiUrl() {
    return this._loiUrl;
  }

  private _racecarUrl!: string;
  get racecarUrl() {
    return this._racecarUrl;
  }

  private _lottoUrl!: string;
  get lottoUrl() {
    return this._lottoUrl;
  }

  private _stateUrl!: string;
  get stateUrl() {
    return this._stateUrl;
  }

  private _reactH5Url = 'https://h5-games.pages.dev';
  get reactH5Url() {
    return this._reactH5Url;
  }

  get codePushKey() {
    return this._codePushKey;
  }

  get IMURL() {
    return this._IMURL;
  }
  get imApiUrl() {
    return this._imApiUrl;
  }

  private _moengageAppId = 'Q60RICPHDSGXDX7PXH3NCE7K';

  get moengageAppId() {
    return this._moengageAppId;
  }

  get betbyScriptUrl() {
    return this._betbyScriptUrl;
  }

  get gr8IframeUrl() {
    return this._gr8IframeUrl;
  }

  get downloadDomain() {
    return this._downloadDomain;
  }

  get shareDomain() {
    return this._shareDomain;
  }

  get gamePicCdn() {
    return this._gamePicCdn;
  }

  get fantasyCenterUrl() {
    return this._fantasyCenterUrl;
  }

  // Sentry配置
  get sentryDsn() {
    return process.env.REACT_APP_SENTRY_DSN || '';
  }

  get environment() {
    return ENV_CONFIG.REACT_APP_ENV || 'development';
  }

  constructor() {
    // 原始URL配置（保持与 singam-main 一致）
    const originalUrls = {
      baseUrl: ENV_CONFIG.REACT_APP_API_BASE_URL,
      induswinUrl:
        ENV_CONFIG.REACT_APP_API_INDUSWIN_URL ||
        ENV_CONFIG.REACT_APP_API_BASE_URL,
      sportsUrl:
        ENV_CONFIG.REACT_APP_API_SPORTS_URL ||
        ENV_CONFIG.REACT_APP_API_BASE_URL,
      imApiUrl: ENV_CONFIG.REACT_APP_API_IM_URL || '',
      quick3dUrl:
        ENV_CONFIG.REACT_APP_API_QUICK_URL || ENV_CONFIG.REACT_APP_API_BASE_URL,
      lqiUrl:
        ENV_CONFIG.REACT_APP_API_QUICK_URL || ENV_CONFIG.REACT_APP_API_BASE_URL,
      loiUrl:
        ENV_CONFIG.REACT_APP_API_QUICK_URL || ENV_CONFIG.REACT_APP_API_BASE_URL,
      racecarUrl:
        ENV_CONFIG.REACT_APP_API_RACECAR_URL ||
        ENV_CONFIG.REACT_APP_API_BASE_URL,
    };

    // 使用适配器处理多域名逻辑，如果不需要多域名则使用原始配置
    const adaptedUrls = adaptNetworkUrls(
      ENV_CONFIG.REACT_APP_ENV,
      originalUrls,
      ENV_CONFIG.REACT_APP_API_BASE_URL,
    );

    // 应用适配后的URLs
    this._baseUrl = adaptedUrls.baseUrl!;
    this._induswinUrl = adaptedUrls.induswinUrl!;
    this._sportsUrl = adaptedUrls.sportsUrl!;
    this._imApiUrl = adaptedUrls.imApiUrl!;
    this._quick3dUrl = adaptedUrls.quick3dUrl!;
    this._lqiUrl = adaptedUrls.lqiUrl!;
    this._loiUrl = adaptedUrls.loiUrl!;
    this._racecarUrl = adaptedUrls.racecarUrl!;

    // 其他配置保持不变
    this._lottoUrl =
      ENV_CONFIG.REACT_APP_API_LOTTO_URL || ENV_CONFIG.REACT_APP_API_BASE_URL;
    this._stateUrl =
      ENV_CONFIG.REACT_APP_API_STATE_URL || ENV_CONFIG.REACT_APP_API_BASE_URL;
    this._reactH5Url = ENV_CONFIG.REACT_APP_API_H5GAMES_URL || this._reactH5Url;
    this._moengageAppId = this._moengageAppId;
    this._codePushKey =
      ENV_CONFIG.REACT_APP_ENV === 'prod'
        ? '5naQjnOyKbgw_rtH5Wel30umaDgYv2qxoNvCV'
        : ENV_CONFIG.REACT_APP_ENV === 'uat'
        ? 'eij_AQ1ONgfae30PHCTkTKl4sSiUNfX_8oOUv'
        : ENV_CONFIG.REACT_APP_ENV === 'test'
        ? 'qvLFQgxtWE5xfTxeqPs8FlBPSRgc9LKqgRmq3'
        : '';
    this._IMURL = ENV_CONFIG.REACT_APP_IM_URL || '';
    this._betbyScriptUrl = ENV_CONFIG.REACT_APP_BETBY_SCRIPT_URL || '';
    this._gr8IframeUrl = ENV_CONFIG.REACT_APP_GR8_IFRAME_URL || '';
    this._downloadDomain = ENV_CONFIG.REACT_APP_DOWNLOAD_DOMAIN || '';
    this._shareDomain = ENV_CONFIG.REACT_APP_SHARE_DOMAIN || '';
    this._gamePicCdn =
      ENV_CONFIG.REACT_APP_GAME_PIC_CDN || 'cdn.cloudfrontstatic.com';
    this._fantasyCenterUrl =
      ENV_CONFIG.REACT_APP_FANTASY_CENTER_URL ||
      (ENV_CONFIG.REACT_APP_ENV === 'prod' || ENV_CONFIG.REACT_APP_ENV === 'uat'
        ? 'https://center.pick11.xyz/'
        : 'https://test-fantasy-center.game712.com/');
  }
}

export const envConfig = new Config();
export default envConfig;
